import * as dayjs from "dayjs";

declare module "dayjs" {
  interface Dayjs {
    toISOTzRemove(): string;
  }
}

export default (option: any, dayjsClass: any) => {
  dayjsClass.prototype.toISOTzRemove = function (): string {
    return this.format().slice(0, 19);
  };
};
